import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ReadWikisQueryVariables = {
  search?: Types.Maybe<Types.Scalars['String']>
};


export type ReadWikisQuery = (
  { __typename?: 'Query' }
  & { wikis: Array<(
    { __typename?: 'Wiki' }
    & Pick<Types.Wiki, '_id' | 'files' | 'filePreview' | 'tag' | 'topic' | 'body' | 'created' | 'deletionPeriod' | 'deletionRule' | 'modified' | 'inactive'>
    & { createdBy: Types.Maybe<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'upn' | 'firstName' | 'lastName' | 'name' | 'email' | 'department' | 'roles'>
    )>, modifiedBy: Types.Maybe<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'upn' | 'firstName' | 'lastName' | 'name' | 'email' | 'department' | 'roles'>
    )>, provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title'>
    )> }
  )> }
);

export type CreateWikiMutationVariables = {
  input: Types.WikiCreateInput
};


export type CreateWikiMutation = (
  { __typename?: 'Mutation' }
  & { createWiki: (
    { __typename?: 'Wiki' }
    & Pick<Types.Wiki, '_id'>
  ) }
);

export type UpdateWikiMutationVariables = {
  id: Types.Scalars['ID'],
  update: Types.WikiUpdateInput
};


export type UpdateWikiMutation = (
  { __typename?: 'Mutation' }
  & { updateWiki: (
    { __typename?: 'Wiki' }
    & Pick<Types.Wiki, '_id'>
  ) }
);

export type DeleteWikisMutationVariables = {
  ids: Array<Types.Scalars['ID']>
};


export type DeleteWikisMutation = (
  { __typename?: 'Mutation' }
  & { deleteWikis: Array<(
    { __typename?: 'Wiki' }
    & Pick<Types.Wiki, '_id'>
  )> }
);

export type UpdateWikiCheckMutationVariables = {
  update: Types.WikiCheckUpdate
};


export type UpdateWikiCheckMutation = (
  { __typename?: 'Mutation' }
  & { updateWikiCheck: (
    { __typename?: 'UserWikiCheck' }
    & Pick<Types.UserWikiCheck, 'user' | 'modifiedWiki' | 'modifiedNews'>
  ) }
);

export const ReadWikisDocument = gql`
    query ReadWikis($search: String) {
  wikis(filter: {OR: [{topic: {REGEX: $search, OPTIONS: "i"}}, {tag: {REGEX: $search, OPTIONS: "i"}}]}, sort: {modified: DESC}) {
    _id
    files
    filePreview
    tag
    topic
    body
    created
    deletionPeriod
    deletionRule
    createdBy {
      _id
      type
      upn
      firstName
      lastName
      name
      email
      department
      roles
    }
    modified
    modifiedBy {
      _id
      type
      upn
      firstName
      lastName
      name
      email
      department
      roles
    }
    inactive
    provingGround {
      _id
      title
    }
  }
}
    `;

    export function useReadWikisQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadWikisQuery, ReadWikisQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadWikisQuery, ReadWikisQueryVariables>(ReadWikisDocument, baseOptions);
    };
      export function useReadWikisLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadWikisQuery, ReadWikisQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadWikisQuery, ReadWikisQueryVariables>(ReadWikisDocument, baseOptions);
      };
      
export type ReadWikisQueryHookResult = ReturnType<typeof useReadWikisQuery>;
export type ReadWikisQueryResult = ApolloReactCommon.QueryResult<ReadWikisQuery, ReadWikisQueryVariables>;
export const CreateWikiDocument = gql`
    mutation CreateWiki($input: WikiCreateInput!) {
  createWiki(input: $input) {
    _id
  }
}
    `;
export type CreateWikiMutationFn = ApolloReactCommon.MutationFunction<CreateWikiMutation, CreateWikiMutationVariables>;

    export function useCreateWikiMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateWikiMutation, CreateWikiMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateWikiMutation, CreateWikiMutationVariables>(CreateWikiDocument, baseOptions);
    };
export type CreateWikiMutationHookResult = ReturnType<typeof useCreateWikiMutation>;
export type CreateWikiMutationResult = ApolloReactCommon.MutationResult<CreateWikiMutation>;
export type CreateWikiMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateWikiMutation, CreateWikiMutationVariables>;
export const UpdateWikiDocument = gql`
    mutation UpdateWiki($id: ID!, $update: WikiUpdateInput!) {
  updateWiki(id: $id, update: $update) {
    _id
  }
}
    `;
export type UpdateWikiMutationFn = ApolloReactCommon.MutationFunction<UpdateWikiMutation, UpdateWikiMutationVariables>;

    export function useUpdateWikiMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWikiMutation, UpdateWikiMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateWikiMutation, UpdateWikiMutationVariables>(UpdateWikiDocument, baseOptions);
    };
export type UpdateWikiMutationHookResult = ReturnType<typeof useUpdateWikiMutation>;
export type UpdateWikiMutationResult = ApolloReactCommon.MutationResult<UpdateWikiMutation>;
export type UpdateWikiMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWikiMutation, UpdateWikiMutationVariables>;
export const DeleteWikisDocument = gql`
    mutation DeleteWikis($ids: [ID!]!) {
  deleteWikis(ids: $ids) {
    _id
  }
}
    `;
export type DeleteWikisMutationFn = ApolloReactCommon.MutationFunction<DeleteWikisMutation, DeleteWikisMutationVariables>;

    export function useDeleteWikisMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteWikisMutation, DeleteWikisMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteWikisMutation, DeleteWikisMutationVariables>(DeleteWikisDocument, baseOptions);
    };
export type DeleteWikisMutationHookResult = ReturnType<typeof useDeleteWikisMutation>;
export type DeleteWikisMutationResult = ApolloReactCommon.MutationResult<DeleteWikisMutation>;
export type DeleteWikisMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteWikisMutation, DeleteWikisMutationVariables>;
export const UpdateWikiCheckDocument = gql`
    mutation UpdateWikiCheck($update: WikiCheckUpdate!) {
  updateWikiCheck(update: $update) {
    user
    modifiedWiki
    modifiedNews
  }
}
    `;
export type UpdateWikiCheckMutationFn = ApolloReactCommon.MutationFunction<UpdateWikiCheckMutation, UpdateWikiCheckMutationVariables>;

    export function useUpdateWikiCheckMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWikiCheckMutation, UpdateWikiCheckMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateWikiCheckMutation, UpdateWikiCheckMutationVariables>(UpdateWikiCheckDocument, baseOptions);
    };
export type UpdateWikiCheckMutationHookResult = ReturnType<typeof useUpdateWikiCheckMutation>;
export type UpdateWikiCheckMutationResult = ApolloReactCommon.MutationResult<UpdateWikiCheckMutation>;
export type UpdateWikiCheckMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWikiCheckMutation, UpdateWikiCheckMutationVariables>;